import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserInterest = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.60278 11.2222C11.3389 11.2222 13.5556 13.4389 13.5556 16.175C13.5556 16.6306 13.1861 17 12.7306 17H2.825C2.36944 17 2 16.6306 2 16.175C2 13.4389 4.21667 11.2222 6.95278 11.2222H8.60278ZM7.77778 9.66667C5.93611 9.66667 4.44444 8.175 4.44444 6.33333C4.44444 4.49167 5.93611 3 7.77778 3C9.61944 3 11.1111 4.49167 11.1111 6.33333C11.1111 8.175 9.61944 9.66667 7.77778 9.66667Z",
		fill: "#0D2976"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.2949 5.73795L15.5 6.01518L15.7051 5.73795C16.0469 5.27455 16.5965 5 17.1803 5C18.1852 5 19 5.79821 19 6.78259V6.81741C19 8.32009 17.0873 10.0652 16.0893 10.8112C15.9197 10.9371 15.7119 11 15.5 11C15.2881 11 15.0789 10.9384 14.9107 10.8112C13.9127 10.0652 12 8.32009 12 6.81741V6.78259C12 5.79821 12.8148 5 13.8197 5C14.4035 5 14.9531 5.27455 15.2949 5.73795Z",
		fill: "#0D2976"
	})]
});
export default SvgUserInterest;
